import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, API } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("mm_session");
    if (!t) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      localStorage.removeItem("mm_session");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = () => {
    const url = `${API}/oauth/google/login`;
    // Google refuses to render its login inside an iframe (e.g. the preview pane),
    // which triggers a 403 "you do not have access to this document" page.
    // Break out to the top-level window; if that is blocked (cross-origin), open a new tab.
    const inIframe = window.self !== window.top;
    if (inIframe) {
      try {
        window.top.location.href = url;
      } catch {
        window.open(url, "_blank", "noopener");
      }
    } else {
      window.location.href = url;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("mm_session");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
